import React from 'react';
import { formatAmountInput, parseAmountInput, amountToEnglishWords } from '../../lib/formatInr';

type Props = {
  id: string;
  label?: string;
  value: string;
  onChange: (rawDigitsOrFormatted: string) => void;
  /** Controlled value is the raw numeric string without commas (e.g. "105000"). */
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  hint?: string;
};

/**
 * Money input with Indian comma grouping + English amount words underneath.
 * Parent stores the plain numeric string; this formats for display.
 */
export function AmountInput({
  id,
  label,
  value,
  onChange,
  placeholder = '0',
  disabled,
  className = '',
  hint,
}: Props) {
  const numeric = parseAmountInput(value);
  const display = value === '' ? '' : formatAmountInput(value);
  const words = numeric > 0 ? amountToEnglishWords(numeric) : '';

  return (
    <div className={`w-full min-w-0 ${className}`}>
      {label ? (
        <label className="app-label" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <input
        id={id}
        type="text"
        inputMode="decimal"
        className="app-field box-border w-full min-w-0 max-w-full tabular-nums"
        value={display}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => {
          const next = e.target.value.replace(/[^\d.]/g, '');
          // Keep a single plain numeric string in parent state.
          onChange(next);
        }}
      />
      {words ? (
        <p className="mt-1 text-[11px] leading-snug text-emerald-800/90">{words}</p>
      ) : hint ? (
        <p className="mt-1 text-[11px] leading-snug text-zinc-500">{hint}</p>
      ) : null}
    </div>
  );
}
